import { GUI } from "dat.gui";

export class GuiHelper {
	constructor() {
		this.gui = new GUI();
		this.data = 500;
	}

	camareHelper(camara, name = "Camera") {
		const cameraFolder = this.gui.addFolder(name);
		cameraFolder.add(camara.position, "x", 0, 10);
		cameraFolder.open();
	}

	objectsRotation(object, name = "Object", min = -10, max = 10) {
		const objectFolder = this.gui.addFolder(name);
		objectFolder.add(object.rotation, "x", min, max).step(0.001).listen();
		objectFolder.add(object.rotation, "y", min, max).step(0.001).listen();
		objectFolder.add(object.rotation, "z", min, max).step(0.001).listen();
		objectFolder.open();
	}

	objectsPosition(object, name = "Object", min = -15, max = 15) {
		const objectFolder = this.gui.addFolder(name);
		objectFolder.add(object.position, "x", min, max).step(0.001).listen();
		objectFolder.add(object.position, "y", min, max).step(0.001).listen();
		objectFolder.add(object.position, "z", min, max).step(0.001).listen();
		objectFolder.open();
	}
	objectsSizen(object, name = "Object", min = -10, max = 10) {
		const objectFolder = this.gui.addFolder(name);
		objectFolder.add(object.scale, "x", min, max).step(0.001).listen();
		objectFolder.add(object.scale, "y", min, max).step(0.001).listen();
		objectFolder.open();
		// objectFolder.add(object.scale, "z", min, max);
	}

	objectTargetController() {
		// const controlsControls = gui.addFolder("control");
		// controlsControls.add(this.control.target, "x", -15, 15).step(0.001).listen();
		// controlsControls.add(this.control.target, "y", -15, 15).step(0.001).listen();
		// controlsControls.add(this.control.target, "z", -15, 15).step(0.001).listen();
		// controlsControls.open();
	}

	updateTexture() {
		const update = {
			updateMateria: function () {
				alert("Changing");
				// scope.material.dispose();
				// scope.material.map = texture1();
			},
		};
		this.gui.add(update, "updateMateria");
	}

	open(object) {
		object.open();
	}
}
